import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import { CREATE_NEW_PASSWORD_MUTATION } from '../../../../api/mutations';
import { CreatePasswordData } from './CreatePasswordForm';
import { useMutation } from '@apollo/client';
import { LOGIN } from '../../../../constants/routes';

const useCreatePasswordRequest = () => {
    const navigate = useNavigate();
    const [ createNewPassword ] = useMutation(CREATE_NEW_PASSWORD_MUTATION)


    const handleCreatePassword = async (values: CreatePasswordData, setError: (error: string) => void) => {

        try {
            const req = await createNewPassword({ variables: values });

            if (req.data?.createNewPassword?.message) {
                if (req.data.createNewPassword.__typename == "ErrorType") return setError(req.data?.createNewPassword?.message);
    
                return navigate(LOGIN);
                
            }
            if (req.errors) {
                setError(req.errors.toString());
            }
    
        } catch (e){
            setError(String(e))
        }
    }

    return {
        createPassword: handleCreatePassword
    }
}

export default useCreatePasswordRequest;